<template>
  <div class="cd-taken">
    <section v-for="section in sections" :key="section.key" class="cd-taken__section">
      <div v-if="section.name" class="rd-section">
        <h2>{{ section.name }}</h2>
        <span class="rd-num">
          <template v-if="showTaken"><b>{{ section.taken }}</b> / {{ section.ordered }}</template>
          <template v-else>{{ section.ordered }}</template>
        </span>
      </div>

      <ui-table
        variant="report"
        :columns="columns"
        :rows="section.rows"
        :row-key="(row) => row.key"
        :totals="sectionTotals(section)"
        :total-label="$t('total')"
      >
        <template #head-shift="{ column }">
          <report-shift-tag :shift="column.shift.id"></report-shift-tag>
        </template>

        <template #cell-shift="{ row, column }">
          <template v-if="row.cells[column.shift.id].ordered">
            <span
              v-if="showTaken"
              class="rd-cellbar"
              :class="{ 'is-complete': row.cells[column.shift.id].complete }"
            >
              <span class="rd-cellbar__text">
                {{ row.cells[column.shift.id].taken }} / {{ row.cells[column.shift.id].ordered }}
              </span>
              <span class="rd-cellbar__bar"><i :style="{ width: `${row.cells[column.shift.id].percent}%` }"></i></span>
            </span>
            <span v-else class="rd-num">{{ row.cells[column.shift.id].ordered }}</span>
          </template>
          <span v-else class="is-zero">–</span>
        </template>

        <template #cell-total="{ row }">
          <template v-if="showTaken">
            <b>{{ row.taken }}</b> / {{ row.ordered }}
            <span class="rd-mini" :class="{ 'is-complete': row.complete }">
              <i :style="{ width: `${row.percent}%` }"></i>
            </span>
          </template>
          <b v-else>{{ row.ordered }}</b>
        </template>
      </ui-table>
    </section>
  </div>
</template>

<script>
import ReportShiftTag from "@/components/report/shared/ReportShiftTag.vue";

/**
 * Tabela "preuzeto / poručeno" po smenama za izveštaje firme na računaru (Preuzeti obroci, Preuzeto, Preuzeto po
 * firmama): redovi su obroci ili firme, kolone smene sa trakom napretka, pa ukupno. Samo prikazuje; podatke,
 * pretragu, štampu i Excel daje ekran. Bez `showTaken` (firma ne sme da vidi preuzimanje) prikazuje samo poručeno.
 */
export default {
  name: "CompanyDesktopTakenTable",
  components: { ReportShiftTag },
  props: {
    /** [{ key, name, ordered, taken, rows: [{ key, name, ordered, taken, percent, complete, cells: { [smena]: { ordered, taken, percent, complete } } }] }] */
    sections: { type: Array, default: () => [] },
    /** smene koje su kolone: [{ id, key, label }] */
    shifts: { type: Array, default: () => [] },
    nameLabel: { type: String, default: "" },
    showTaken: { type: Boolean, default: true },
  },
  computed: {
    /** Kolone tabele: naziv reda, smene (sa trakom napretka) i ukupno. */
    columns() {
      return [
        { key: "name", label: this.nameLabel, name: true },
        ...this.shifts.map((shift) => ({ key: `s${shift.id}`, slot: "shift", shift, align: "end" })),
        { key: "total", label: this.$t("total"), align: "end", num: true },
      ];
    },
  },
  methods: {
    /** Zbirni red: poručeno (i preuzeto) po smeni i ukupno, kao tekst. */
    sectionTotals(section) {
      const sums = this.totals(section);
      const text = (taken, ordered) => (this.showTaken ? `${taken} / ${ordered}` : String(ordered));
      const result = { total: text(section.taken, section.ordered) };
      this.shifts.forEach((shift) => {
        const cell = sums.cells[shift.id];
        result[`s${shift.id}`] = cell.ordered ? text(cell.taken, cell.ordered) : "–";
      });
      return result;
    },
    /** Zbir po smeni za podnožje (ostaje u skladu sa prikazanim redovima). */
    totals(section) {
      const cells = {};
      this.shifts.forEach((shift) => {
        cells[shift.id] = section.rows.reduce(
          (sum, row) => ({
            ordered: sum.ordered + row.cells[shift.id].ordered,
            taken: sum.taken + row.cells[shift.id].taken,
          }),
          { ordered: 0, taken: 0 }
        );
      });
      return { cells };
    },
  },
};
</script>

<style lang="scss">
.cd-taken__section + .cd-taken__section {
  margin-top: 20px;
}
</style>
